import axios from './api';

export default {
  getPlans() {
    return axios.get('/api/plans').then(res => res.data);
  },
  getById(id){
    return axios.get(`/api/plan/${id}`).then(res => res.data);
  },
  createPlan(plan) {
    return axios.post('/api/plan', plan).then(res => res.data);
  },
  removePlan(id) {
    return axios.delete(`/api/plan/${id}`).then(res => res.data);
  },
  updatePlan(id, plan) {
    return axios.put(`/api/plan/${id}`, plan).then(res => res.data);
  },
}